// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lVSS","left":"styles_left__1RTOR","right":"styles_right__2yccw","alert":"styles_alert__2vOE5"};